import {
  generateBindings,
  observableValue,
  useEffect,
  useRef,
  useSharedState,
  view,
  WritableObservableValue,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-checkbox';
import { Checkbox as MdcCheckbox } from '@material/mwc-checkbox';
import { html } from 'lit';
import { ref } from 'lit/directives/ref.js';

export const [Checkbox] = view('esui-mwc-checkbox', {
  Props: class {
    checked = observableValue(false);
    disabled = false;
    indeterminate = observableValue(false);
    reducedTouchTarget = false;
    value = '';
  },

  mapBuilder: CheckboxBuilder => (checked: WritableObservableValue<boolean>) =>
    CheckboxBuilder().checked(checked),

  template(props) {
    const checked = useSharedState(props.checked);

    const inputRef = useRef<MdcCheckbox>();
    useEffect(
      element => {
        element.focus = () => {
          inputRef.value?.focus();
        };

        element.click = () => {
          inputRef.value?.click();
        };
      },
      [inputRef.value]
    );

    const indeterminate = useSharedState(props.indeterminate);

    const computedProps = generateBindings(props, ['checked', 'indeterminate']);

    function handleChange(e: { target: HTMLInputElement }) {
      checked.value = e.target.checked;
      indeterminate.value = false;
    }

    return html`
      <mwc-checkbox
        ${ref(inputRef)}
        ${spread({ ...computedProps })}
        .checked="${checked.value}"
        .indeterminate="${indeterminate.value}"
        @change="${handleChange}"
      ></mwc-checkbox>
    `;
  },
});
